export {
  default,
  type LabelButtonAs,
  type LabelButtonSize,
  type LabelButtonBorderRadius,
  type LabelButtonProps,
  type LabelButtonDestructuredProps,
  type KeyofLabelButtonProps,
  type LabelButtonForwardedProps,
  type LabelButtonHTMLElement,
  type LabelButtonComponentProps,
  type LabelButtonDefaultExport,
} from './LabelButton';
